var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, P, PCSS, Defaults, ViewChild } from '@pacem/pacem-core';
import { PacemCompositeWidgetElement } from '../types';
//namespace Pacem.Components.Cms {
/**
 * UI widget container that eases dragdrop-based enrollment into composite widgets.
 */
let PacemWidgetPickerElement = class PacemWidgetPickerElement extends PacemCompositeWidgetElement {
    register(item) {
        const retval = super.register(item);
        if (retval) {
            item.hide = true;
        }
        return retval;
    }
};
__decorate([
    ViewChild(P + '-drag-drop')
], PacemWidgetPickerElement.prototype, "_dragDrop", void 0);
PacemWidgetPickerElement = __decorate([
    CustomElement({
        tagName: P + '-widget-picker', shadow: Defaults.USE_SHADOW_ROOT,
        template: `<${P}-repeater datasource="{{ :host.items }}">
    <template>
        <${P}-panel behaviors="{{ [::_dragDrop] }}" class="${PCSS}-widget-itempicker display-flex flex-fill flex-middle flex-nowrap">
            <i class="${PCSS}-icon flex-auto" dragger>drag_indicator</i>
            <${P}-icon icon="{{ ^item.metadata.display.icon }}" class="flex-auto ${PCSS}-margin margin-x-1"></${P}-icon>
            <${P}-text text="{{ ^item.metadata.display.name }}"></${P}-text>
        </${P}-panel>
    </template>
</${P}-repeater>
<${P}-drag-drop handle-selector="i.${PCSS}-icon[dragger]"></${P}-drag-drop>
<${P}-content></${P}-content>`
    })
], PacemWidgetPickerElement);
export { PacemWidgetPickerElement };
